var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoAndHeading } from '@/components/logo-and-heading.component';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { StepLayout } from '@/components/step-layout.component';
import { Typography } from '@mui/material';
import { pageImages } from '@/pages/images';
export function HeadphoneInformation() {
    return (_jsx(StepLayout, { image: pageImages.guyListeningWithHeadphones, progress: {
            phase: 0,
            step: 5,
        }, heading: _jsx(LogoAndHeading, { className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), content: _jsxs("div", __assign({ className: "flex flex-col max-w-[30rem] m-8 gap-6" }, { children: [_jsx(Typography, { children: "Please use stereo headphones or earphones that do not have noise cancellation or any filters applied. Bluetooth headphones or earphones often have mono audio output only." }), _jsx(Typography, { children: "Try using wired headphones or earphones." })] })), nav: _jsx(NavigationButtonsContainer, { children: _jsx(NavigationButton, { navigate: '/setup/headphone-check', variant: "outlined", label: "Previous" }) }) }));
}
